import { LimiteTipoPeriodo, PeriodoLimiteModel } from './../models/limits';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Auth } from '../../../autentication/Auth';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { AutenticationService } from '../../../autentication/autentication.service';
import { LimitsService } from '../limits.service';
import { ModalSucessComponent } from '../../../shared/modal-sucess/modal-sucess.component';
import { SharedModalInfoComponent } from '../../../shared/modal-info/modal-info.component';
import { Util } from '../../../utils/util';
import { AdjustLimitResponse, AdjustLimitSituation } from '../models/adjust-limit';

@Component({
  selector: 'app-limits-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class LimitsSignatureComponent implements OnInit {
	public submitted = false;
	public form: FormGroup;
	public text: string;

	private selectedLimit: PeriodoLimiteModel;
	private pendingIncreaseLimit: boolean;

	constructor(
		private router: Router,
		public dialog: MatDialog,
		private autenticationService: AutenticationService,
		private limitService: LimitsService
	) { }

	ngOnInit() {
		this.selectedLimit = JSON.parse(sessionStorage.getItem('selectedAdjustedLimit'));

		if (this.invalidParams()) {
			this.goBack();
		}
	}

	invalidParams(): boolean {
		return this.selectedLimit === undefined || this.selectedLimit.tipo === undefined;
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
	}

	submit(message: boolean) {
		this.submitted = message;

		if (this.submitted && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
		const model = this.selectedLimit;

		this.limitService.changeLimitValue(model).subscribe(data => {
			if (data.Sucesso) {
				const result = Util.keysToCamel(data.Retorno) as AdjustLimitResponse;
				this.pendingIncreaseLimit = result.situacao === AdjustLimitSituation.PEDENTE_APROVACAO ? true : false;
				this.openModal();
			}
		}, error => {
			this.handleError(error);
		});
	}

	public openModal() {
		switch (this.selectedLimit.tipo) {
			case LimiteTipoPeriodo.PIX_DIURNO:
			case LimiteTipoPeriodo.QRCODE_PIX_SAQUE_TROCO_DIURNO:
				this.text = this.pendingIncreaseLimit ? 'Limite diurno solicitado com sucesso' : 'Limite diurno ajustado com sucesso' ;
				break;
			case LimiteTipoPeriodo.TED_DIURNO:
				this.text = this.pendingIncreaseLimit ? 'Limite TED solicitado com sucesso' : 'Limite TED ajustado com sucesso';
				break;
			case LimiteTipoPeriodo.PIX_NOTURNO:
			case LimiteTipoPeriodo.QRCODE_PIX_SAQUE_TROCO_NOTURNO:
				this.text = this.pendingIncreaseLimit ? 'Limite noturno solicitado com sucesso' : 'Limite noturno ajustado com sucesso';
				break;
			default:
				break;
		}

		const dialogRef = this.dialog.open(ModalSucessComponent, {
			width: '350px',
			data: {
				title: '',
				topText:
					`<img src="../../../assets/success.svg" alt="Success" class="icone-sucesso"/>`,
				description: this.text,
				backButton: '',
				confirmButton: 'OK',
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				if (this.pendingIncreaseLimit) {
					this.removeSavedLimitsFromSessionStorage();
					this.router.url === '/minha-conta/meus-limites/assinatura' ? this.router.navigate(['/minha-conta/meus-limites/']) : this.router.navigate(['/pix/limites/']);
					this.openAwaitLimitRaise();
				} else {
					this.removeSavedLimitsFromSessionStorage();
					this.router.url === '/minha-conta/meus-limites/assinatura' ? this.router.navigate(['/minha-conta/meus-limites/']) : this.router.navigate(['/pix/limites/']);
				}

			}
		});
	}

	public openAwaitLimitRaise() {
		this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: 'Sua solicitação de limite foi enviada!',
				text: 'Por segurança, seu novo limite leva no mínimo de 24h para ser ajustado.',
				btnName: 'Entendi',
			}
		});
	}

	removeSavedLimitsFromSessionStorage() {
		sessionStorage.removeItem('selectedAdjustedLimit');
		sessionStorage.removeItem('selectedlimitTransferData');
		sessionStorage.removeItem('limitTransferData');
	}

	handleError = (error) => {
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		this.router.url === '/minha-conta/meus-limites/assinatura' ? this.router.navigate(['/minha-conta/meus-limites/']) : this.router.navigate(['/pix/limites/']);
	}

	goBack = () => this.router.navigate(['pix/limites/ajustar/']);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limits/signature/signature.component.ts